import { UPLOADING_PHOTOS } from 'mk/autogenerated/translations/SubmitButton.d5ad438725f87b2aa350e8830f692869'
import Btn, { BtnType } from 'mk2/components/Btn';
import { PhotoUploadStatus } from 'mk2/helpers/form.reducers';
import { AppState } from 'mk2/reducers';
import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector, isDirty as formIsDirty, isSubmitting as formIsSubmitting, submit } from 'redux-form';

interface OwnProps {
    className?: string;
    formName: string;
    label: string;
    icon?: string;
    img?: React.ReactNode;
    imgIfDisabled?: React.ReactNode;
    disableIfNotDirty?: boolean;
    canBeVisuallyDisabled?: boolean;
    btnType?: BtnType;
}

interface StateProps {
    // requestUser: UserEntity;
    // requestUserPermissions: string[];
    isDirty: boolean;
    isSubmitting: boolean;
    isUploadingPhotos: boolean;
}

interface DispatchProps {
    onSubmit();
}

class SubmitButton extends React.Component<OwnProps & StateProps & DispatchProps> {

    public static defaultProps = {
        disableIfNotDirty: true,
    };

    public render() {
        const {
            label, icon, img, imgIfDisabled, isSubmitting, disableIfNotDirty, isDirty, isUploadingPhotos,
            className, btnType, canBeVisuallyDisabled,
        } = this.props;

        const disabled = (disableIfNotDirty && !isDirty) || isUploadingPhotos;

        return (
            <Btn
                className={className}
                type={btnType || BtnType.Blue}
                label={isUploadingPhotos ? UPLOADING_PHOTOS + '...' : label}
                icon={isUploadingPhotos ? 'fa-spin fa-spinner' : icon}
                img={isUploadingPhotos ? null : (disabled ? imgIfDisabled : img)}
                onClick={this.onSubmit}
                hasSpinner={isSubmitting}
                disabled={disabled}
                canBeVisuallyDisabled={canBeVisuallyDisabled}
                submitFormBtn
            />
        );
    }

    private onSubmit = (event: React.FormEvent<HTMLButtonElement>) => {
        event.preventDefault(); // Do not bubble up
        event.stopPropagation();
        this.props.onSubmit();
    };
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const { formName } = ownProps;

    const selector = formValueSelector(formName);
    const currentUploads = selector(state, 'photos') as any[] || [];
    const isFormUploadingPhotos: boolean = currentUploads ? currentUploads.findIndex((u) => u.status === PhotoUploadStatus.PENDING) >= 0 : false;

    return {
        // requestUser: getRequestUser(state),
        // requestUserPermissions: getRequestPermissions(state),
        isDirty: formIsDirty(formName)(state),
        isSubmitting: formIsSubmitting(formName)(state),
        isUploadingPhotos: isFormUploadingPhotos,
    };
}

function mapDispatchToProps(dispatch, ownProps: OwnProps) {
    const { formName } = ownProps;

    return {
        onSubmit: () => dispatch(submit(formName)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmitButton);
